export const convertOzToLbOz = (
  weightOzInput?: number | string
): { weightLb: number; weightOz: number } => {
  const parsedValue =
    weightOzInput === '' || weightOzInput === undefined || weightOzInput === null
      ? 0
      : Number(weightOzInput);

  if (isNaN(parsedValue) || parsedValue < 0) {
    return { weightLb: 0, weightOz: 0 };
  }

  const totalOz = parsedValue;
  let weightLb = Math.floor(totalOz / 16);
  let remainderOz = Math.round(totalOz - weightLb * 16);

  if (remainderOz === 16) {
    weightLb += 1;
    remainderOz = 0;
  }

  return { weightLb, weightOz: remainderOz };
};

export const convertGmToKgGm = (
  weightGmInput?: number | string
): { weightKg: number; weightGm: number } => {
  const parsedValue =
    weightGmInput === '' || weightGmInput === undefined || weightGmInput === null
      ? 0
      : Number(weightGmInput);

  if (isNaN(parsedValue) || parsedValue < 0) {
    return { weightKg: 0, weightGm: 0 };
  }

  const totalGm = parsedValue;
  let weightKg = Math.floor(totalGm / 1000);
  let remainderGm = Math.round(totalGm - weightKg * 1000);

  if (remainderGm === 1000) {
    weightKg += 1;
    remainderGm = 0;
  }

  return { weightKg, weightGm: remainderGm };
};
